// import { Button, Tab, Tabs, Icon } from 'vant'
import Vant from 'vant'
import { Toast  } from 'vant'
import { commonParams } from './common/utils'
import 'vant/lib/index.css'

import { Locale } from 'vant'
import enUS from 'vant/es/locale/lang/en-US'
import esMX from 'vant/es/locale/lang/es-ES'
import ptBR from 'vant/es/locale/lang/pt-BR'

const lang = commonParams().lang

const localeLang: any = {
  enUS,
  esMX,
  esCO: esMX,
  es419: esMX,
  ptBR,
}

Locale.use(lang || 'en-US', localeLang[lang?.replace('-', '')] || enUS)

export const initVant = (app: any) => {
  // app.use(Button)
  // app.use(Tab)
  // app.use(Tabs)
  // app.use(Icon)
  app.use(Vant)
  Toast.setDefaultOptions({
    position: 'bottom',
  })
}
